import * as React from "react"
import {Check} from "lucide-react"

import {cn} from "../../shadCn/lib/utils"
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem,} from "../../shadCn/components/ui/command"
import {Popover, PopoverContent, PopoverTrigger,} from "../../shadCn/components/ui/popover"
import {CommandList} from "cmdk";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {useDispatch} from "react-redux";
import {refresh} from "../../redux/slice/apiSlice";
import {isEmpty} from "../commonmethod/CommonMethod";
import {ComboBoxSelectorTrigger} from "./ComboBoxSelectorTrigger";

/**
 *
 * @param options               [id, name]형태의 배열목록
 * @param required              필수옵션
 * @param target                field명
 * @param defaultValue          초기값
 * @param id                    entity Key
 * @param listener              수정 listener
 * @returns {JSX.Element}
 * @constructor
 */
function SelectComboBoxForUpdate({options, required, target, defaultValue, id, listener, optionTarget, search, fnc, auth}){
    const [open, setOpen] = React.useState(false)
    const [value, setValue] = React.useState(defaultValue ? defaultValue : null)
    const dispatch = useDispatch();

    const isRequiredEmpty = required && defaultValue && isEmpty(defaultValue);

    const handler = async (selected) => {
        let optionValue = optionTarget ? selected[optionTarget] : selected.id
        if(required && value === optionValue){
            alert("필수값입니다.")
            return;
        }

        if(value === optionValue){
            setValue(null);
            selected = 0;
            optionValue = optionTarget ? (isNaN(selected[optionTarget]) ? 0 : null) : null;
        }else{
            setValue(optionValue)
        }

        const response = await listener({id: id, fieldName : target, value : optionValue});
        if(response.status === 200){
            fnc((prev) => ({
                ...prev,
                [target]: optionValue, // target에 해당하는 값을 업데이트
            }));
            handleActiveToast({message: "데이터가 수정되었습니다"});
        }else if(response.status === 403){
            handleActiveError({message: "권한이 없습니다."});
        }else{
            handleActiveError({message: "알 수 없는 에러 발생."});
        }

        setOpen(false)
        dispatch(refresh(true))
    }

    if(options) {
        const displayLabel = value ? options.find((option) => option.id === value)?.name : "선택";

        return (
            <div className="simms-drawer-field selector-field">
                <div className="selector-root selector-root--ios no-drag">
                    <Popover open={auth ? open : false} onOpenChange={setOpen} modal>
                        <PopoverTrigger asChild>
                            <ComboBoxSelectorTrigger
                                label={displayLabel}
                                open={open}
                                selected={Boolean(value)}
                                isRequiredEmpty={isRequiredEmpty}
                            />
                        </PopoverTrigger>

                    <PopoverContent className="w-[200px] p-0" align={"start"}>
                    <Command>
                        {search &&
                            <>
                                <CommandInput placeholder="검색" />
                                <CommandEmpty>검색결과 없음</CommandEmpty>
                            </>
                        }
                        <CommandGroup>

                            <CommandList className="max-h-[10rem] overflow-y-auto w-full">
                            {options.map((option) => (
                                <CommandItem
                                    key={option.id}
                                    value={option.id}
                                    onSelect={() => handler(option)}
                                    className={"text-[12px]"}
                                >
                                    <Check
                                        className={cn(
                                            "mr-2 h-4 w-4",
                                            value === option.id ? "opacity-100" : "opacity-0"
                                        )}
                                    />
                                    {option.name}
                                </CommandItem>
                            ))}
                            </CommandList>
                        </CommandGroup>
                    </Command>
                </PopoverContent>
                </Popover>
                </div>
            </div>
        )
    }
}

export {SelectComboBoxForUpdate}